<template>
  <div>
    <div class="titlePart">审核</div>
    <div
      style="background: #F3F4F9;height: 80px;display: flex;align-items: center;justify-content: space-between;padding: 0 30px"
    >
      <div style="font-size: 20px;color: #2A2A2A;font-weight: 550;">
        {{ reviewInfo.enterpriseName }}</div>
      <div style="font-size: 14px;color: #2A2A2A">
        <span style="display: inline-block;margin-right: 20px">证件类型:
          {{ typeFormat(reviewInfo) }}</span>
        <span>证件代码: {{ reviewInfo.enterpriseCode }}</span>
      </div>
    </div>
    <div class="infoPart">
      <div class="titleInner">
        <div class="title">基本信息</div>
      </div>
      <div
        class="infoInner"
        style=""
      >
        <div class="part">
          <el-form
            label-position="right"
            label-width="100px"
            :model="reviewInfo"
          >
            <el-form-item label="授权对象:">
              <!-- {{ reviewInfo.bankName }} -->
              信易贷金融服务平台
            </el-form-item>
            <el-form-item label="基本开户行:">{{ reviewInfo.bankName }}
            </el-form-item>
            <el-form-item label="法人姓名:">{{ reviewInfo.legalPerson }}
            </el-form-item>
            <el-form-item label="身份证照片:">{{ reviewInfo.operatorName }}
            </el-form-item>
          </el-form>
          <show-image
            class="img1"
            :image-url="reviewInfo.operatorIdFrontUrl"
          />
          <show-image
            class="img2"
            :image-url="reviewInfo.operatorIdBackUrl"
          />
        </div>
        <div class="part">
          <div class="label">经营执照:</div>
          <show-image
            class="img3"
            :image-url="reviewInfo.businessLicenseUrl"
          />
          <div
            class="label"
            style="margin-top: 10px"
          >企业授权书:</div>
          <show-image
            class="img3"
            :image-url="reviewInfo.authUrl"
          />
          <!-- <div class="down" @click="handleDown"><img src="../../assets/images/down_icon.png" alt="" />下载授权书模板</div> -->
        </div>
      </div>
    </div>
    <div class="footPart">
      <el-button
        type="primary"
        class="myPrimaryButton"
        @click="handleReview"
      >审核</el-button>
      <el-dialog
        title="审核结果"
        :visible.sync="dialogVisible"
        width="450px"
        custom-class="myDialog"
        :show-close="false"
        :modal-append-to-body="false"
        :lock-scroll="false"
      >
        <el-form
          ref="review"
          :model="reviewForm"
          :rules="reviewRule"
          label-width="80px"
        >
          <el-form-item
            label="结果:"
            prop="examineStatus"
          >
            <el-radio-group v-model="reviewForm.examineStatus">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="reviewForm.examineStatus === 2"
            label="原因:"
            prop="examineReason"
          >
            <el-input
              type="textarea"
              v-model="reviewForm.examineReason"
            ></el-input>
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="myMainButton"
            @click="dialogVisible = false"
          >取 消</el-button>
          <el-button
            type="primary"
            class="myPrimaryButton"
            @click="handleSubmit"
            :loading="submitLoading"
          >确 认</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ShowImage from "../ShowImage";
import { updateAuth } from "../../api/review";
export default {
  components: { ShowImage },
  data () {
    return {
      dialogVisible: false,
      submitLoading: false,
      reviewForm: {
        examineReason: "",
        examineStatus: 1,
      },
      reviewRule: {
        examineReason: [
          { required: true, message: '请输入原因', trigger: 'blur' }
        ]
      },
      cardOption: [
        { label: "身份证", value: "1" },
        { label: "其他", value: "2" },
      ],
    }
  },
  computed: {
    reviewInfo () {
      return this.$store.state.review.reviewInfo;
    }
  },
  methods: {
    handleReview () {
      this.dialogVisible = true;
      this.reviewForm = {
        examineReason: "",
        examineStatus: 1,
      }
    },
    handleSubmit () {
      this.$refs["review"].validate((valid) => {
        if (valid) {
          if (this.submitLoading) return;
          this.submitLoading = true;
          const params = {
            ...this.reviewForm,
            id: this.reviewInfo.id,
          }
          updateAuth(this.sendParam(params)).then(res => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$message.success("操作成功");
            this.$store.commit("setIsList", true);
          });
        }
      });
    },
    // 翻译
    typeFormat (row) {
      return row.legalPersonIdType && this.cardOption.find(x => x.value === row.legalPersonIdType).label;
    },
    // 下载
    handleDown () {
      const xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/file/authFileTemp", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "企业授权书模板.pdf";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send();
    }
  }
}
</script>

<style lang="less" scoped>
.titlePart {
  color: #2981ee;
  font-size: 24px;
  font-weight: bold;
  border-left: 6px solid #2981ee;
  padding-left: 20px;
  margin-bottom: 20px;
}
.infoPart {
  padding: 20px 30px 0;
  .titleInner {
    border-bottom: 1px solid #f3f4f9;
    padding-bottom: 10px;
    padding-left: 20px;
    .title {
      color: #2a2a2a;
      font-size: 18px;
      font-weight: 550;
      padding-left: 20px;
      border-left: 5px solid #2981ee;
    }
  }
  .infoInner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 150px;
    /deep/.el-form {
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label {
          font-size: 15px;
          font-weight: 550;
          color: #2a2a2a;
        }
      }
    }
    .img1 {
      width: 218px;
      height: 120px;
      //background: url("../../assets/images/face.png") no-repeat;
      //background-size: cover;
    }
    .img2 {
      width: 218px;
      height: 120px;
      margin-top: 20px;
      //background: url("../../assets/images/back.png") no-repeat;
      //background-size: cover;
    }
    .img3 {
      width: 277px;
      height: 152px;
    }
    .label {
      margin-bottom: 20px;
      color: #252525;
      font-size: 15px;
      font-weight: 550;
    }
    .down {
      width: fit-content;
      margin-top: 5px;
      color: #2981ee;
      font-size: 16px;
      font-weight: 550;
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        margin-right: 5px;
      }
    }
  }
}
.footPart {
  border-top: 1px solid #f3f4f9;
  padding: 30px 30px 10px;
  text-align: right;
  /deep/.myDialog {
    text-align: left;
  }
}
</style>
